import gql from 'graphql-tag'

export const GET_GEOFENCES = gql`
  query Geofences($filter: GetGeofencesFilter) {
    geofences(filter: $filter) {
      isSuccessful
      message
      geofences {
        data {
          geofenceId
          companyId
          fenceName
          type
          polyData
          circData
          address
          addressDetail
          province
          city
          postalCode
          category
          contactName
          phoneNo
          isGarage
          isServiceLoc
          serviceLocType
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`
